import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ProfileValues } from '../lib/profileSchema';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';

/**
 * Save the signed-in member's own name (PUT /auth/me), which the server
 * writes to their account and every company's driver record. The profile
 * is fetched again, so Settings and the presence pill show it at once.
 */
export const useUpdateProfile = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values: ProfileValues) => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      await driverApi.updateProfile(values);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['driver-profile'] }),
  });
};
